import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import {
  dateformat,
  diasDeSemanaUtil,
  getSumaTimeHelper,
} from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldAularioComponent from '../../aulario/components/SelectFieldAulario';
import { oneDocentesService } from '../../docentes/DocentesService';
import CardDocenteComponent from '../../docentes/components/CardDocente';
import SelectFieldDocentesComponent from '../../docentes/components/SelectFieldDocentes';
import SelectFieldMateriasComponent from '../../materias/components/SelectFieldMaterias';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import { saveHorariosAction } from '../HorariosAction';
import { PARAMS_HORARIOS, SETTINGS_HORARIOS } from '../HorariosReducer';

const FormHorarios = ({
  setOpenForm = () => {},
  setOpenModalDelete = () => {},
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const horariosStore = Redux.useSelector((state) => state.horarios);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const activo = horariosStore.activo;

  const initData = {
    dia: '',
    horaInicio:
      horariosStore.settings.newHorario?.horaInicio ??
      entHorariosClasesStore.activo?.start ??
      '',
    horaFinal: horariosStore.settings.newHorario?.horaFinal ?? '',
    grupo: 1,
    day: '',
    idDocente: '',
    idMateria: '',
    idSeccion: '',
    idAula: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    horaInicio: false,
    horaFinal: false,
    idMateria: false,
    idSeccion: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [loadingGetOne, setLoadingGetOne] = React.useState(false);

  const [docenteSelect, setDocenteSelect] = React.useState(null);
  const [diaSelect, setDiaSelect] = React.useState(null);
  const [numBloques, setNumBloques] = React.useState(1);

  const [materias, setMaterias] = React.useState('');
  const [secciones, setSecciones] = React.useState('');

  const diasSemana = [];
  diasDeSemanaUtil.forEach((el) => {
    const dias = entHorariosClasesStore.activo.dias;
    dias.forEach((item) => {
      if (el.id === item.num || el.dia === item) {
        diasSemana.push(el);
      }
    });
  });

  React.useEffect(() => {
    async function fetchData() {
      if (
        !activo &&
        horariosStore.params.idDocente &&
        !loginStore.isAdminTeacher
      ) {
        await getDocenteData(horariosStore.params.idDocente);
      }

      setHoraFinalInit(entHorariosClasesStore.activo.start);
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setHoraFinalInit(start) {
    const dateTime = getSumaTimeHelper(
      start,
      entidadesStore.ajustes.minutosAcademicos,
    );
    _handleSetDataField(
      CONST.horaFinal.name,
      dateformat(dateTime, { isHHmm: true }),
    );
  }

  React.useEffect(() => {
    setNumBloques(1);
    setHoraFinalInit(data.horaInicio);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.horaInicio]);

  React.useEffect(() => {
    function fetchData() {
      if (!docenteSelect) return;

      if (
        !docenteSelect.diasClases ||
        !docenteSelect.diasClases.dias ||
        docenteSelect.diasClases?.dias?.length === 0
      ) {
        notify('El docente no tiene días de clases asignados', {
          warning: true,
        });
        return;
      }

      if (docenteSelect.diasClases.dias.length === 1) {
        setDiaSelect(docenteSelect.diasClases.dias[0]);
      }

      setData({
        ...data,
        idMateria:
          docenteSelect.materias.length === 1
            ? docenteSelect.materias[0].id
            : horariosStore.params.idMateria || '',
      });

      if (horariosStore.settings.newHorario) {
        if (
          docenteSelect.diasClases.dias.includes(
            horariosStore.settings.newHorario.dia.dia,
          )
        ) {
          setDiaSelect(horariosStore.settings.newHorario.dia.dia);
        } else {
          notify(
            `El día: ${horariosStore.settings.newHorario.dia.dia} no se encuentra asignado al docente`,
            { warning: true },
          );
        }
      }

      docenteSelect.materias.forEach((el) => {
        setMaterias((prev) => [...prev, el.materia]);
      });
      docenteSelect.secciones.forEach((el) => {
        setSecciones((prev) => [...prev, el.seccion]);
      });
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docenteSelect]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!activo) return;
      await getDocenteData(activo.docente.id);
      let values = {};
      Object.keys(data).map((key) => (values[key] = activo[key]));
      setTimeout(
        () =>
          setData({
            ...data,
            ...values,
            idDocente: activo.docente.id,
            idMateria: activo.materia.id,
            idSeccion: activo.seccion.id,
            idAula: activo.aula?.id,
            idEstatus: activo.estatus.id,
          }),
        1000,
      );
      setDiaSelect(activo.dia);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const getDocenteData = async (id) => {
    if (!id) return;
    setData({
      ...data,
      dia: null,
      idDocente: id,
    });
    setDiaSelect(null);
    setLoadingGetOne(true);

    const res = await oneDocentesService(id);
    await setDocenteSelect(res.data.data);

    setLoadingGetOne(false);
  };

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!diaSelect) {
      notify('Falta seleccionar un día de la semana', { warning: true });
      return;
    }

    if (_validDataForm()) {
      const idDocente = loginStore.isAdminTeacher
        ? usuEntidadesStore.activo.id
        : docenteSelect?.id;
      dispatch({
        type: PARAMS_HORARIOS,
        payload: {
          ...horariosStore.params,
          idDocente:
            horariosStore.params.idSeccion ||
            horariosStore.params.idNivelAcademico
              ? null
              : idDocente,
        },
      });
      setLoadingSave(true);
      const values = {
        ...data,
        dia: diaSelect,
        idEntidad: entidadesStore.activo.id,
        idDocente,
        idHorarioClase: entHorariosClasesStore.activo?.id,
      };
      const res = await saveHorariosAction(
        { dispatch, notify },
        activo?.id,
        values,
        horariosStore.params,
      );
      if (res) {
        dispatch({
          type: SETTINGS_HORARIOS,
          payload: {
            ...horariosStore.settings,
            newHorario: null,
          },
        });
      }
      setLoadingSave(false);
    }
  };

  function compararDia(a) {
    if (loginStore.isAdminTeacher) {
      return !docentesStore.activo.diasClases.dias.includes(a) ?? true;
    }
    return !docenteSelect.diasClases?.dias.includes(a) ?? true;
  }

  function calcularTimeEnd() {
    if (data.horaInicio) {
      setNumBloques(numBloques + 1);
      const minutos = entidadesStore.ajustes.minutosAcademicos;
      const time = getSumaTimeHelper(
        data.horaFinal ?? data.horaInicio,
        minutos,
      );
      _handleSetDataField(
        CONST.horaFinal.name,
        dateformat(time, { isHHmm: true }),
      );
    }
  }

  return (
    <Box component="form">
      <Grid container spacing={1}>
        <Grid item xs={12} md={12}>
          <Typography variant="h6" color="initial">
            {activo ? 'Editar horario' : 'Nuevo Horario'}
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <LoadingWidget
            isLoading={loadingSave || loadingGetOne}
            isActivo={activo}
            text={loadingGetOne ? 'Cargando docente...' : null}
          />
        </Grid>

        {!loginStore.isAdminTeacher && (
          <Grid item xs={12} md={12}>
            {activo || docenteSelect ? (
              <CardDocenteComponent mini data={docenteSelect} />
            ) : (
              <SelectFieldDocentesComponent
                isEmpty={false}
                isAll={false}
                open={!horariosStore.params.idDocente && !activo}
                value={data.idDocente}
                onChange={(idDocente) => getDocenteData(idDocente)}
              />
            )}
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          {docenteSelect || loginStore.isAdminTeacher ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" color="initial">
                  Seleccione un día de clase
                </Typography>
                {diasSemana.map((el, i) =>
                  compararDia(el.dia) ? null : (
                    <Button
                      key={i}
                      variant={diaSelect === el.dia ? 'contained' : 'outlined'}
                      sx={{ mr: 1 }}
                      onClick={() => {
                        setDiaSelect(el.dia);
                        setData({
                          ...data,
                          day: el.id,
                        });
                      }}
                    >
                      {diaSelect === el.dia ? el.dia : el.abrev}
                    </Button>
                  ),
                )}
              </Grid>

              <Grid item xs={12} md={12}>
                <SelectFieldMateriasComponent
                  id="formMaterias"
                  data={loginStore.isAdminTeacher ? null : materias}
                  value={data.idMateria}
                  isEmpty={false}
                  isAll={false}
                  onChange={(idMateria) => {
                    _handleSetDataField(CONST.materia.idName, idMateria);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <SelectFieldSeccionesComponent
                  id="formSecciones"
                  data={loginStore.isAdminTeacher ? null : secciones}
                  value={data.idSeccion}
                  isAll={false}
                  isEmpty={false}
                  onChange={(idSeccion) => {
                    _handleSetDataField(CONST.seccion.idName, idSeccion);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack direction="row" alignItems="center">
                  <TextField
                    fullWidth
                    size="small"
                    type="time"
                    label={CONST.horaInicio.label}
                    value={data.horaInicio}
                    onChange={(e) =>
                      _handleSetDataField(CONST.horaInicio.name, e.target.value)
                    }
                    id={CONST.horaInicio.name}
                    InputProps={{
                      inputProps: { min: 1 },
                    }}
                  />
                  <BotonComponent
                    text="+1"
                    green
                    tooltip="Suma un (1) bloque de tiempo"
                    ml={1}
                    click={calcularTimeEnd}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={6}>
                <Stack direction="row" alignItems="center">
                  <BotonComponent
                    text="-1"
                    red
                    tooltip="Resta un (1) bloque de tiempo"
                    mr={1}
                    disabled={numBloques === 1}
                    click={() => {
                      if (numBloques === 1) return;
                      setNumBloques(numBloques - 1);
                      const minutos = entidadesStore.ajustes.minutosAcademicos;
                      const time = getSumaTimeHelper(
                        data.horaFinal ?? data.horaInicio,
                        -minutos,
                      );
                      _handleSetDataField(
                        CONST.horaFinal.name,
                        dateformat(time, { isHHmm: true }),
                      );
                    }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    type="time"
                    label={CONST.horaFinal.label}
                    value={data.horaFinal}
                    onChange={(e) =>
                      _handleSetDataField(CONST.horaFinal.name, e.target.value)
                    }
                    id={CONST.horaFinal.name}
                    InputProps={{
                      inputProps: { min: 1 },
                    }}
                  />
                </Stack>
                <Typography variant="caption" color="initial">
                  Bloques asignados: {numBloques}
                </Typography>
              </Grid>

              {(loginStore.isRoot ||
                loginStore.isAdmin ||
                loginStore.isEntity) && (
                <Grid item xs={12} md={6}>
                  <SelectFieldAularioComponent
                    value={data.idAula}
                    isAll={false}
                    onChange={(idAula) => {
                      _handleSetDataField(CONST.aula.idName, idAula);
                    }}
                  />
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label={CONST.grupo.label}
                  value={data.grupo}
                  onChange={(e) =>
                    _handleSetDataField(CONST.grupo.name, e.target.value)
                  }
                  id={CONST.grupo.name}
                  InputProps={{
                    inputProps: { min: 1 },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <EstatusField
                  value={data.idEstatus}
                  onChange={(e) =>
                    _handleSetDataField(CONST.estatus.idName, e.target.value)
                  }
                  isEstatus
                  required
                />
              </Grid>

              <Grid item xs={12} md={12} align="center">
                <BotonComponent
                  click={_handleSubmit}
                  text="GUARDAR"
                  disabled={loadingSave}
                  green
                  saveIcon
                  mr={2}
                />
                {activo && (
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setOpenModalDelete(true);
                    }}
                    sx={{ mr: 2 }}
                  >
                    ELIMINAR
                  </Button>
                )}
                <BotonComponent
                  click={() => setOpenForm(false)}
                  text="CANCELAR"
                  closeIcon
                  black
                  mr={2}
                />
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormHorarios;
